const cardsData = [
  {
    title: '长风渡',
    desc: '白敬亭宋轶演绎先婚后爱，古装甜宠天花板',
    tag: '古装爱情',
    score: '9.2',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20poster%20style%2C%20elegant%20couple%20in%20traditional%20hanfu%20clothing%2C%20soft%20romantic%20lighting%2C%20ancient%20Chinese%20architecture%20background%2C%20warm%20golden%20and%20red%20color%20tones%2C%20cinematic%20drama%20poster%20composition%2C%20high%20quality%20photography&width=400&height=560&seq=card-tv-01&orientation=portrait',
  },
  {
    title: '三体',
    desc: '科幻巨制震撼来袭，刘慈欣原著改编硬核宇宙',
    tag: '科幻悬疑',
    score: '9.5',
    img: 'https://readdy.ai/api/search-image?query=Sci%20fi%20drama%20series%20poster%2C%20mysterious%20cosmic%20background%20with%20stars%20and%20nebula%2C%20futuristic%20technology%20elements%2C%20dark%20blue%20and%20silver%20color%20palette%2C%20cinematic%20composition%2C%20dramatic%20lighting%2C%20high%20quality%20sci%20fi%20art&width=400&height=560&seq=card-tv-02&orientation=portrait',
  },
  {
    title: '繁花',
    desc: '王家卫首部电视剧，胡歌演绎九十年代上海传奇',
    tag: '年代剧情',
    score: '9.4',
    img: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20nostalgic%20drama%20poster%2C%20vintage%20cityscape%20with%20neon%20lights%2C%20elegant%20man%20in%20retro%20suit%2C%20warm%20golden%20hour%20lighting%2C%20classic%20Chinese%20cinema%20aesthetic%2C%20atmospheric%20mood%2C%20film%20grain%20texture&width=400&height=560&seq=card-tv-03&orientation=portrait',
  },
  {
    title: '与凤行',
    desc: '赵丽颖林更新再度携手，仙侠玄幻爱恨交织',
    tag: '仙侠玄幻',
    score: '8.9',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20drama%20poster%2C%20ethereal%20immortal%20beings%20in%20flowing%20robes%2C%20magical%20particles%20and%20phoenix%20motifs%2C%20heavenly%20palace%20background%2C%20soft%20pastel%20colors%2C%20dreamy%20atmosphere%2C%20high%20quality%20fantasy%20art&width=400&height=560&seq=card-tv-04&orientation=portrait',
  },
  {
    title: '墨雨云间',
    desc: '复仇爽剧天花板，吴谨言演绎黑莲花逆袭之路',
    tag: '古装复仇',
    score: '9.0',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20revenge%20drama%20poster%2C%20strong%20female%20lead%20in%20dark%20elegant%20hanfu%2C%20rainy%20ancient%20alley%20setting%2C%20dramatic%20moody%20lighting%2C%20ink%20wash%20painting%20style%20background%2C%20intense%20expression%2C%20cinematic%20quality&width=400&height=560&seq=card-tv-05&orientation=portrait',
  },
  {
    title: '莲花楼',
    desc: '成毅曾舜晞携手探案，武侠悬疑全新力作',
    tag: '武侠悬疑',
    score: '9.3',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20wuxia%20mystery%20drama%20poster%2C%20martial%20arts%20master%20with%20flowing%20hair%2C%20ancient%20Chinese%20landscape%20with%20mountains%20and%20mist%2C%20traditional%20ink%20painting%20style%2C%20elegant%20sword%2C%20atmospheric%20fog%2C%20high%20quality%20art&width=400&height=560&seq=card-tv-06&orientation=portrait',
  },
  {
    title: '你也有今天',
    desc: '陈星旭章若楠律政甜宠，职场恋爱两不误',
    tag: '都市甜宠',
    score: '8.7',
    img: 'https://readdy.ai/api/search-image?query=Modern%20romantic%20law%20drama%20poster%2C%20handsome%20lawyer%20and%20beautiful%20female%20lead%20in%20office%20setting%2C%20warm%20natural%20lighting%2C%20contemporary%20city%20background%2C%20soft%20romantic%20color%20palette%2C%20professional%20yet%20sweet%20atmosphere%2C%20high%20quality%20photography&width=400&height=560&seq=card-tv-07&orientation=portrait',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">精选剧集</h2>
          <p className="mt-2 text-sm text-foreground-500">编辑精选，高分好剧一网打尽</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {cardsData.map((card) => (
            <div key={card.title} className="group cursor-pointer">
              <div className="relative aspect-[2/3] rounded-xl overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  title={`${card.title} - 窝窝影院`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute top-2 right-2 bg-accent-500 text-background-50 text-xs font-bold px-2 py-0.5 rounded-md">
                  {card.score}
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="mt-2.5 px-0.5">
                <h3 className="text-sm font-medium text-foreground-900 truncate">{card.title}</h3>
                <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">{card.desc}</p>
                <span className="inline-block mt-1.5 text-xs text-accent-600 bg-accent-50 px-2 py-0.5 rounded">{card.tag}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}